const headerNavList = [
  {
    i18Name: 'hosting',
    path: '/hosting',
  },
  {
    i18Name: 'vps',
    path: '/vps',
  },
  {
    i18Name: 'domains',
    path: '/domain',
  },
  {
    i18Name: 'servers',
    path: '/arenda-servera',
  },
  {
    i18Name: 'constructor-header',
    path: '/service/constructor',
  },
]

export default headerNavList
